import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRequest } from "shared/utils/fetch-api";
import parseToTimestamp from "shared/utils/parseToTimestamp";

export const fetchTaskCase = createAsyncThunk(
    'contract/fetchTaskCase',
    async ({ TaskID }: {
        TaskID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'getTaskCase', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { task: data.Task, fetchTime: parseToTimestamp(new Date()), TaskID };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);

export const fetchFileDownload = createAsyncThunk(
    'contract/fetchFileDownload',
    async ({ TaskID, FileID }: {
        TaskID: string,
        FileID: string
    }, { rejectWithValue }) => {
        try {
            const requestBody = {
                "TaskID": TaskID,
                "FileID": FileID
            };

            const response = await getRequest(requestBody, 'dms-hr', 'downloadFile', 'POST');
            const data = await response.json();
            if (data.Errors.length === 0) {
                return { FileData: data.File.DataBase64, FileName: data.File.Name };
            } else {
                return rejectWithValue(data.Errors);
            }
        } catch (error: any) {
            return rejectWithValue(error.message);
        }
    }
);